/**
 * @generated SignedSource<<21ab5cf61dafd7c93e4ed9f2a5b2cd89>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentFragment$data = {
  readonly id: string;
  readonly numChildren?: number;
  readonly " $fragmentSpreads": FragmentRefs<"CommentCommentsFragment" | "CommentDisplayFragment" | "CommentReplyFragment">;
  readonly " $fragmentType": "CommentFragment";
};
export type CommentFragment$key = {
  readonly " $data"?: CommentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "bottomLevel"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "leafLevel"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "level1"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "level2"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "level3"
    },
    {
      "defaultValue": "HOT",
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "topLevel"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CommentDisplayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CommentReplyFragment"
    },
    {
      "condition": "topLevel",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v0/*:: as any*/),
            {
              "kind": "Literal",
              "name": "topLevel",
              "value": true
            }
          ],
          "kind": "FragmentSpread",
          "name": "CommentCommentsFragment"
        }
      ]
    },
    {
      "condition": "level1",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "level1",
              "value": true
            },
            (v0/*:: as any*/)
          ],
          "kind": "FragmentSpread",
          "name": "CommentCommentsFragment"
        }
      ]
    },
    {
      "condition": "level2",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "level2",
              "value": true
            },
            (v0/*:: as any*/)
          ],
          "kind": "FragmentSpread",
          "name": "CommentCommentsFragment"
        }
      ]
    },
    {
      "condition": "level3",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "level3",
              "value": true
            },
            (v0/*:: as any*/)
          ],
          "kind": "FragmentSpread",
          "name": "CommentCommentsFragment"
        }
      ]
    },
    {
      "condition": "bottomLevel",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "bottomLevel",
              "value": true
            },
            (v0/*:: as any*/)
          ],
          "kind": "FragmentSpread",
          "name": "CommentCommentsFragment"
        }
      ]
    },
    {
      "condition": "leafLevel",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numChildren",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Comment",
  "abstractKey": null
};
})();

(node as any).hash = "0ac5d938fe0d22910676d3101e425d24";

export default node;
